import { DatePicker } from "@mui/x-date-pickers";
import cn from "classnames";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
  name: string;
  type?: string;
  label?: string;
  placeholder?: string;
  error?: string;
  className?: string;
  defaultValue?: string | number;
  required?: boolean;
  [any: string]: any;
}

const FORMAT = "YYYY-MM-DD";

export const DateInput = React.forwardRef((props: IProps, ref: any) => {
  const {
    className,
    defaultValue,
    error,
    format = FORMAT,
    label,
    name,
    onBlur,
    onChange,
    openTo = "year",
    required,
    value,
    variant = "outlined",
    ...rest
  } = props;
  const { t } = useTranslation("admin");
  const id = `input-${name}`;
  const rootClasses = cn("marapp-qa-date-input", {
    [className]: !!className,
  });

  // Ensure input value is properly formatted as a dayjs object
  const inputValue =
    value || defaultValue ? dayjs(value || defaultValue) : null;

  return (
    <DatePicker
      onChange={(newValue) => {
        const date = newValue ? dayjs(newValue) : null;
        if (!date || date.isValid()) onChange(date);
      }}
      format={format}
      label={t(label)}
      onClose={onBlur}
      openTo={openTo}
      value={inputValue}
      slotProps={{
        textField: {
          name: name,
          fullWidth: true,
          required: required,
          variant: variant,
          error: !!error,
          helperText: error && t(error),
          className: rootClasses,
          placeholder: dayjs().format(format),
          FormHelperTextProps: {
            className: `marapp-qa-error marapp-qa-error-${id}`,
          },
          onBlur: onBlur,
        },
        field: {
          clearable: true,
        },
      }}
      {...rest}
    />
  );
});
